exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/collect-products-autocomplete/collect-products-autocomplete.component.scss
// module id = ../../../../../src/app/shared/components/collect-products-autocomplete/collect-products-autocomplete.component.scss
// module chunks = main